export enum UserOnlineStatusType {
  Offline,
  Online,
  Away
}
